import { render } from "./CollapsibleWrapper.vue?vue&type=template&id=52e6580c"
import script from "./CollapsibleWrapper.vue?vue&type=script&lang=js"
export * from "./CollapsibleWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__